import { render, staticRenderFns } from "./MsComboBoxDropdown.vue?vue&type=template&id=a849560e&scoped=true"
import script from "./MsComboBoxDropdown.vue?vue&type=script&lang=js"
export * from "./MsComboBoxDropdown.vue?vue&type=script&lang=js"
import style0 from "./MsComboBoxDropdown.vue?vue&type=style&index=0&id=a849560e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a849560e",
  null
  
)

export default component.exports